import React, { useEffect, useState, useRef, useCallback} from 'react';
import { Grid, 
  TextField,FormControl, Typography, Divider,
  Button, FormLabel, RadioGroup, FormControlLabel, Box,
  Radio, InputAdornment, FormGroup, Checkbox, Autocomplete,
  InputLabel, Select, MenuItem, List,
  ListItem, ListItemText, ListItemIcon, Stack
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import TimePicker from '@mui/lab/TimePicker';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Loader } from "@googlemaps/js-api-loader";
import { useSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {approveLibrary, getAmenities, getLibraryTypes, rejectLibrary, saveAndApproveLibrary } from 'services/libraries';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import useConfirm from 'core/hooks/useConfirm';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PropertyBankDetails from '../../BankDetails';
import ScrollDialog from 'components/ScrollDialog';

const PropertyInfo = ({cities, states, onLibraryApprovRjected, propertyId = null, propertyData={} }) => {

  const defaultValues = {
    name: '',
    price: '',
    city:'',
    country:'India',
    state: '',  
    contactNumber: '',
    type: '',
    amenities: '',
    workingDays: '',
    pin:'',
    seatCount:'',
    overview:'',
    searchArea:'',
    hourlyBookingsEnabled: false,
  };

  const mapOptions = {
    center: {
      lat: 12.9715987,
      lng: 77.5945627
    },
    zoom: 12,
    // disableDefaultUI: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
  };

  // const amenitiesList = {
  //   "AC": false,
  //   "Books": false,
  //   "Drinking Water": false,
  //   "Internet": false,
  //   "Parking": false,
  //   "Study Materials": false,
  //   "Wi-Fi": false
  // };

  const weekDays = {
    "Sunday": false,
    "Monday": false,
    "Tuesday": false,
    "Wednesday": false,
    "Thursday": false,
    "Friday": false,
    "Saturday": false
  };

  /** Hooks */
  const [fromHrs, setFromHrs] = useState(new Date());
  const [libraryTypes, setLibraryTypes] = useState([]);
  const [toHrs, setToHrs] = useState(new Date());
  const [amenities, setAmenitiesState] = useState({});
  const [amenitiesList, setAmenitiesList] = useState({});
  const [workingDays, setWorkingDays] = useState({...weekDays});
  const [terms, setTerms] = useState([]);
  const [area, setArea] = useState('');
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [locationCoordinates, setLocationCoordinates] = useState(getMapCoordinates(propertyData));
  const [liveDataLocationCoordinates, setLiveDataLocationCoordinates] = useState({});
  const { handleSubmit, control, formState: { errors }, reset, watch } = useForm({
    mode: 'onTouched',
    defaultValues
  });
  const confirm = useConfirm();

  const placesInputRef = useRef(null);
  const termsInputRef = useRef(null);
  const markerRef = useRef(null);
  const mapRef = useRef(null);
  const googleRef = useRef(null);
  
  const liveMapRef = useRef(null);
  const liveMarkerRef = useRef(null);
  const initRef = useRef(false);


  const [liveData, setLiveData] = useState(null);

  const getLibraryTypesList = useCallback(() => {
    getLibraryTypes().then(({response, error}) => {
      if(response){
        setLibraryTypes(response)
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, []);

  const getAmenitiesList = useCallback(() => {
    getAmenities().then(({response, error}) => {
      if(response){
        let _amenities={};
        response.forEach(amenity => {
          _amenities[amenity] = false;
        });
        setAmenitiesState({..._amenities});
        setAmenitiesList({..._amenities});
      } else {
        // enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, []);

  // useEffect(() => {
  //   loadGoogleMaps();
  //   // onSuccess({ libraryId: '775d7cca-5911-4c3b-8c1c-6e313a2b0d6c'});
  //   return () => {};
  // }, []);

  useEffect(() => {
     if(!initRef.current){
      initRef.current = true;
      loadGoogleMaps();
      getLibraryTypesList();
      getAmenitiesList();
    }
  
    if(propertyData?.staged){
      const {library: libraryInfo, libraryDetails = {}, libraryMetadata, libraryTerms = []} = propertyData?.staged || {};
      reset({
        name: libraryInfo?.name,
        price: libraryInfo?.price?.cost,
        city: libraryInfo.address?.city,
        country:'India',
        state: libraryInfo?.address?.state,  
        pin: libraryInfo?.address?.pin,
        seatCount:libraryInfo?.seatCount,
        contactNumber: libraryDetails?.contactNumber,
        type: libraryDetails?.type,
        amenities: '',
        workingDays: '',
        overview: libraryMetadata?.overview,
        // searchArea: libraryInfo.address.area,
        hourlyBookingsEnabled: libraryInfo?.hourlyBookingsEnabled,
      });
      setTerms([...(libraryTerms?.termsAndConditions || [])]);
      setArea(libraryInfo?.address?.area);
      setWorkingDays({...libraryDetails?.workingDays});
      placesInputRef.current.value = libraryInfo?.address?.area;
      if(libraryInfo?.address?.location?.latitude && libraryInfo?.address?.location?.longitude) {
        const cordinates = { lat: libraryInfo.address.location.latitude, lng: libraryInfo.address.location.longitude}
        setLocationCoordinates({latitude:cordinates.lat , longitude: cordinates.lng});
      }

      // Working hours
      if(libraryDetails?.workingHours?.from && libraryDetails?.workingHours?.to) {
        const from = new Date(new Date().toISOString().slice(0, 10) + ' ' + libraryDetails.workingHours.from);
        const to = new Date(new Date().toISOString().slice(0, 10) + ' ' + libraryDetails.workingHours.to);
        setFromHrs(from);
        setToHrs(to);
      }

      if(Array.isArray(libraryDetails?.amenities) && libraryDetails?.amenities.length > 0) {
        setAmenitiesState({...(Object.fromEntries(Object.entries(amenitiesList).map(([amenity, status], index) => [amenity, libraryDetails.amenities.includes(amenity)])))});
      }
    }

    if(propertyData?.live){
      setLiveData({...propertyData.live});
      const liveData = propertyData.live || {};
      if(liveData?.library?.address?.location?.latitude && liveData?.library?.address?.location?.longitude) {
        const liveCordinates = { lat: liveData.library.address.location.latitude, lng: liveData.library.address.location.longitude}
        setLiveDataLocationCoordinates({latitude:liveCordinates.lat , longitude: liveCordinates.lng});
      }
    }

   
    return () => {};
  }, [propertyData, reset]);


  function getMapCoordinates(_propertyData = {} ) {
    const { library: libraryInfo } = _propertyData || {};
    let cordinates = null;
    if(libraryInfo?.address?.location?.latitude && libraryInfo?.address?.location?.longitude) {
      cordinates = { latitude: libraryInfo.address.location.latitude, longitude: libraryInfo.address.location.longitude};
      return cordinates;
    }
    return cordinates;
  }
  
  useEffect(() => {
    if(locationCoordinates?.latitude && locationCoordinates?.longitude && googleRef.current?.maps) {
      const cordinates = { lat: locationCoordinates.latitude, lng: locationCoordinates.longitude}
      if (markerRef.current == null) {
        markerRef.current = new googleRef.current.maps.Marker({
            position: {...cordinates},
            map: mapRef.current,
            title: 'Your Library'
        }); 
      } else {
        markerRef.current.setPosition({...cordinates}); 
      } 
      mapRef.current.setCenter({ ...cordinates });
      mapRef.current.setZoom(12)
    }
    return () => {};
  }, [locationCoordinates]);

  useEffect(() => {
    
    if(!liveMapRef.current && googleRef.current){
      const livePropertyMapEle = document.getElementById("live_property_map");
      liveMapRef.current = new googleRef.current.maps.Map(livePropertyMapEle, mapOptions);
    }

    if(liveDataLocationCoordinates?.latitude && liveDataLocationCoordinates?.longitude && googleRef.current) {
      const cordinates = { lat: liveDataLocationCoordinates.latitude, lng: liveDataLocationCoordinates.longitude}
      // if (liveMarkerRef.current == null) {
        liveMarkerRef.current = new googleRef.current.maps.Marker({
            position: {...cordinates},
            map: liveMapRef.current,
            title: 'Your Library'
        }); 
      // } else {
      //   liveMarkerRef.current.setPosition({...cordinates}); 
      // } 
      liveMapRef.current.setCenter({ ...cordinates });
      liveMapRef.current.setZoom(12)
    }
    return () => {};
  }, [liveDataLocationCoordinates]);
  
  
  const loadGoogleMaps = useCallback(() => {
    

    const loader = new Loader({
      apiKey: "AIzaSyA1VfASPQlVFwh-u2uQozzqecGXAcTTo70",
      version: "weekly",
      libraries: ["places"],
      componentRestrictions: {country: 'in' }
    });

    loader.load().then((google) => {
      googleRef.current =  google;
      const mapEle = document.getElementById("map");
      mapRef.current =  new google.maps.Map(mapEle, mapOptions);
      initPlacesAutoComplete(google, mapRef.current); 

      const livePropertyMapEle = document.getElementById("live_property_map");
      if(livePropertyMapEle && !liveMapRef.current){
        liveMapRef.current = new google.maps.Map(livePropertyMapEle, mapOptions);
      }
      
      // if(locationCoordinates?.latitude && locationCoordinates?.longitude) {
      //   const cordinates = { lat: locationCoordinates.latitude, lng: locationCoordinates.longitude}
      //   markerRef.current = new googleRef.current.maps.Marker({
      //     position: {...cordinates},
      //     map: mapRef.current,
      //     title: 'Your Library'
      //   }); 
      //   mapRef.current.setCenter({ ...cordinates });
      //   mapRef.current.setZoom(12);
      // }
      // console.log('liveDataLocationCoordinates', liveDataLocationCoordinates);
      // if(liveDataLocationCoordinates?.latitude && liveDataLocationCoordinates?.longitude) {
      //   // console.log('liveDataLocationCoordinates', liveDataLocationCoordinates);
      //   const cordinates1 = { lat: liveDataLocationCoordinates.latitude, lng: liveDataLocationCoordinates.longitude}
      //   liveMarkerRef.current = new googleRef.current.maps.Marker({
      //     position: {...cordinates1},
      //     map: liveMapRef.current,
      //     title: 'Your Library'
      //   }); 
      //   liveMapRef.current.setCenter({ ...cordinates1 });
      //   liveMapRef.current.setZoom(12);
      // }

      google.maps.event.addListener(mapRef.current, 'click', function(event) {
        const location = event.latLng;
        setLocationCoordinates({latitude:location.lat() , longitude: location.lng()});
      });

    })
    .catch(e => {
      // do something
      console.log('map error', e)
    });
    
  },[]);

  const initPlacesAutoComplete = (google, map) => {
    const options = {
      fields: [ "geometry","name" ],
      componentRestrictions: {country: 'in'},
      // strictBounds: false,
      // types: ["establishment"],
    };
    const autocomplete = new google.maps.places.Autocomplete(placesInputRef.current, options);
    autocomplete.addListener("place_changed", () => {
      // infowindow.close();
      // marker.setVisible(false);
      const place = autocomplete.getPlace();

      // setValue('searchArea', place.formatted_address, {shouldValidate: true, shouldDirty: true});
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      map.setCenter({lat, lng});
      map.setZoom(12)
      setArea(place.name);
    });
  };

  const handleAmenitiesChange = (event) => {
    setAmenitiesState({
      ...amenities,
      [event.target.name]: event.target.checked,
    });
  };

  const handleWorkingDaysChange = (event) => {
    setWorkingDays({
      ...workingDays,
      [event.target.name]: event.target.checked,
    });
  };
  
  const AddTerms = () => {
    if(termsInputRef.current.value){
      setTerms([...terms, termsInputRef.current.value]);
      termsInputRef.current.value = '';
    } else{
      enqueueSnackbar("Add Terms", {variant: 'error'});
    }
  }

  const deleteTerms = (index) => {
    const temp = [...terms];
    temp.splice(index, 1);
    setTerms([...temp]);
  }


  const onSubmit = (data) => {
    if(!locationCoordinates) {
      enqueueSnackbar("Select library location", {variant: 'error'});
    } else if(!isWorkingDaySelected()) {
      enqueueSnackbar("Select working days", {variant: 'error'});
    } else if(terms.length === 0) {
      enqueueSnackbar("Add Terms", {variant: 'error'});
    } else {
      const postData = formatFormData(data);
      saveAndApproveLibraryData(postData);
    }
  }

  const isWorkingDaySelected = () => ([...(Object.keys(Object.fromEntries(Object.entries(workingDays).filter(([key, value]) => value === true) )))].length > 0);

  const formatFormData = (inputData) => {
    const data = {
      library: {
        libraryId: propertyId,
        address: {
          area,
          city: inputData.city,
          state: inputData.state, 
          country: inputData.country, 
          pin: inputData.pin,
          location: {...locationCoordinates} 
        },
        name: inputData.name,
        hourlyBookingsEnabled: inputData.hourlyBookingsEnabled,
        price: {
          cost: parseFloat(inputData.price),
          rate: inputData.hourlyBookingsEnabled ? 'hour' : 'day'
        },
        seatCount: inputData.seatCount,
      },
      libraryDetails: {
        amenities: [
          ...(Object.keys(Object.fromEntries(Object.entries(amenities).filter(([key, value]) => value === true) )))
        ],
        contactNumber: inputData.contactNumber,
        workingDays: {...workingDays},
        workingHours: {
          from: `${new Date(fromHrs).getHours().toString().padStart(2, "0")}:${new Date(fromHrs).getMinutes().toString().padStart(2, "0")}`,
          to: `${new Date(toHrs).getHours().toString().padStart(2, "0")}:${new Date(toHrs).getMinutes().toString().padStart(2, "0")}`,
        },
        type: inputData.type
      },
      libraryMetadata: {
        overview: inputData.overview
      },
      libraryTerms: {
        termsAndConditions: [
          ...terms
        ]
      }
    };
    return data;
  }

  const saveAndApproveLibraryData = (postData) => {
    saveAndApproveLibrary(postData).then(({response, error}) => {
      if(response){
        var msg = "Library approved successfully";
        enqueueSnackbar(msg, {variant: 'success'});
        onLibraryApprovRjected(response);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onApproveBtnClick = () => {
    confirm({ title: 'Approve Library?', description: 'Are you sure you want to proceed?' })
    .then(() => { 
      onLibraryApproved(propertyId);
    })
  }

  const onRejectBtnClick = () => {
    // confirm({ title: 'Reject Library?', description: 'Are you sure you want to proceed?' })
    // .then(() => { 
    //   onLibraryRejected(propertyId);
    // })
    setOpenRejectModal(true);
  }
  
  const onLibraryApproved = (libraryId) => {
    approveLibrary({libraryId}).then(({response, error}) => {
      if(response){
        enqueueSnackbar("Library approved successfully", {variant: 'success'});
        onLibraryApprovRjected(response);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onLibraryRejected = (data) => {
    onModalClose();
    rejectLibrary({...data}).then(({response, error}) => {
      if(response){
        enqueueSnackbar("Library rejected successfully", {variant: 'success'});
        onLibraryApprovRjected(response);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }


  const onModalClose = useCallback(
    () => {
      setOpenRejectModal(false);
    },
    [],
  );


  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center"><Button variant="contained" color="success" >Live</Button></TableCell>
            <TableCell align="center"><Button variant="contained" color="warning" >Stage</Button></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{verticalAlign: 'top'}}>
              { liveData ? (
                <Box
                  component="form"
                  noValidate 
                  autoComplete="off"
                >
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1}}>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Library Name"
                        value={liveData?.library?.name}
                        disabled
                      />
                    </Grid>

                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 1}}  columnSpacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  sx={{mt: 1}}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="City"
                          value={liveData?.library?.address?.city}
                          disabled
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: 1}}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="State"
                          value={liveData?.library?.address?.state}
                          disabled
                        />
                      </Grid>
                    </Grid>

                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 1}}  columnSpacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: 1}}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Country"
                          value={liveData?.library?.address?.country}
                          disabled
                          />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: 1}}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Pincode"
                          value={liveData?.library?.address?.pin}
                          disabled
                          />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1}}>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Area"
                        value={liveData?.library?.address?.area}
                        disabled
                      />
                      <Box id="live_property_map" component="div" sx={{width: '100%', height: 300}}></Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1}}>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Contact Number"
                        value={liveData?.libraryDetails?.contactNumber}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 1}}>
                      <FormControl>
                        <FormLabel id="live-lib-type-group-label">Library Type</FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="live-lib-type-group-label"
                            name="type"
                            defaultValue={liveData?.libraryDetails?.type}
                          >
                            {/* <FormControlLabel disabled value="Academic" control={<Radio />} label="Academic" />
                            <FormControlLabel disabled value="Private" control={<Radio />} label="Private" />
                            <FormControlLabel disabled value="Public" control={<Radio />} label="Public" />
                            <FormControlLabel disabled value="School" control={<Radio />} label="School" /> */}
                            {libraryTypes.map(type => <FormControlLabel key={type} value={type} control={<Radio />} label={type} />)}
                          </RadioGroup>
                      </FormControl>
                    </Grid> 

                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <FormControl
                        component="fieldset"
                        sx={{ mt: 2.5 }}
                        variant="standard"
                      >
                        <FormGroup row>
                          <FormControlLabel
                            control={<Checkbox name="hourlyBookingsEnabled" />}
                            label="Enable hourly bookings"
                            checked={liveData?.library?.hourlyBookingsEnabled || false}
                            disabled
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    <Grid container item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1}}  columnSpacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: 1}}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Seat Count"
                          value={liveData?.library?.seatCount}
                          disabled
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: 1}}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Price"
                          value={liveData?.library?.price?.cost}
                          disabled
                          InputProps={{
                            endAdornment: <InputAdornment position="start">/{liveData?.library?.hourlyBookingsEnabled ? 'hour' : 'day'}</InputAdornment>,
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1}}  columnSpacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <label style={{color: 'rgba(0, 0, 0, 0.6)'}}>Working Hours</label>
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6}  >
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="From"
                          value={liveData?.libraryDetails?.workingHours?.from}
                          disabled
                          InputProps={{
                            endAdornment: <AccessTimeIcon position="start" />,
                          }}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} md={6} lg={6}>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="To"
                          value={liveData?.libraryDetails?.workingHours?.to}
                          disabled
                          InputProps={{
                            endAdornment: <AccessTimeIcon position="start" />,
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <FormControl
                        component="fieldset"
                        sx={{ mt: 2.5 }}
                        variant="standard"
                      >
                        <FormLabel component="legend">Amenities</FormLabel>
                        <FormGroup row>
                          {Object.keys(amenities).map((type, index) => (
                            <FormControlLabel
                              control={<Checkbox name={type} />}
                              label={type}
                              checked={liveData?.libraryDetails?.amenities?.includes(type) || false}
                              key={type}
                              disabled
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <FormControl
                        component="fieldset"
                        sx={{ mt: 2.5 }}
                        variant="standard"
                      >
                        <FormLabel component="legend">Working Days</FormLabel>
                        <FormGroup row>
                          {Object.keys(weekDays).map((day, index) => (
                            <FormControlLabel
                              control={<Checkbox name={day.toLocaleLowerCase()} />}
                              label={day}
                              checked={liveData?.libraryDetails?.workingDays[day.toLocaleLowerCase()] || false}
                              key={day.toLocaleLowerCase()}
                              disabled
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <TextField
                        value={liveData?.libraryMetadata?.overview}
                        multiline
                        rows={5}
                        margin="normal"
                        label="Overview"
                        size="small"
                        fullWidth
                        disabled
                      />
                    </Grid>

                    <Grid container item xs={12} sm={12} md={12} lg={12} sx={{mt: 2}}>
                      <Grid item xs={12} sm={12} md={12} lg={12} >
                        <Typography variant="h6" gutterBottom component="div">Terms</Typography>
                        <Divider />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12} >
                        <List dense={true}>
                          {liveData?.libraryTerms?.termsAndConditions?.map((ele, index) => (
                            <ListItem key={index}>
                            <ListItemIcon>
                              <ArrowRightIcon />
                            </ListItemIcon>
                            <ListItemText primary={ele} />
                            </ListItem>
                          ))}
                        </List>
                      </Grid>
                    </Grid>

                    {/* <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 2}}>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6" gutterBottom component="div">Bank Details</Typography>
                        <Divider  sx={{mb: 2}}/>
                        <PropertyBankDetails propertyId={propertyId} vendorId={propertyData?.staged?.library?.createdBy} />
                      </Grid>
                    </Grid> */}

                  </Grid>
                </Box>) : null}
            </TableCell> 
            <TableCell sx={{verticalAlign: 'top'}}>
              <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
                <Grid container>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 1}}>
                    <Controller
                      control={control}
                      name="name"
                      id="name"
                      rules={{ required: "Enter your library name" }}
                      render={({field }) => (
                        <TextField
                          {...field}
                          margin="normal"
                          fullWidth
                          size="small"
                          // autoFocus
                          label="Library Name"
                          required
                          error={!!errors?.name}
                        />
                      )}
                    />
                  </Grid>

                  <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 3.9}}  columnSpacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Controller
                        control={control}
                        name="city"
                        id="city"
                        rules={{ required: "Enter your city" }}
                        required
                        render={({field }) => (
                          <Autocomplete
                          {...field}
                          required
                          disablePortal
                          size="small"
                          options={cities}
                          fullWidth={true}
                          defaultValue=''
                          // value={selectedCity}
                          isOptionEqualToValue={(option, value) => (option === value) || ''}
                          onChange={(event, newValue) => {field.onChange(newValue)}}
                          renderInput={(params) => <TextField {...params} error={!!errors?.city} required label="City" />}
                          />
                          )}
                          onChange={([, data]) => data}
                          />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}  sx={{mt: {xs: 4, md: 0}} }>
                        <Controller
                          control={control}
                          name="state"
                          id="state"
                          rules={{ required: "Enter your state" }}
                          render={({field }) => (
                            <Autocomplete
                            {...field}
                            // disablePortal
                            options={states}
                            size="small"
                            name="state"
                            fullWidth={true}
                            defaultValue=''
                            // value={selectedState}
                            isOptionEqualToValue={(option, value) => option === value || ''}
                            onChange={(event, newValue) => {field.onChange(newValue)}}
                            renderInput={(params) => <TextField {...params} {...field} error={!!errors?.state}  required label="State" />}
                            />
                            )}
                            onChange={([, data]) => data}
                            />
                      </Grid>
                    </Grid>

                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 3}}  columnSpacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: 1.8}}>
                        <Controller
                          control={control}
                          required
                          name="country"
                          id="country"
                          rules={{ required: "Enter your country" }}
                          render={({field }) => (
                            <FormControl {...field} fullWidth error={!!errors?.country}>
                              <InputLabel id="country-label">Country</InputLabel>
                              <Select    
                                name="country"                 
                                labelId="country-label"
                                id="country-select"
                                label="Country"
                                size="small"
                                {...field}
                                >
                                <MenuItem value="India">India</MenuItem>
                              </Select>
                            </FormControl>
                          )}
                          />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{mt: {xs: 2.2, md: 0}}} >
                        <Controller
                          control={control}
                          name="pin"
                          required
                          id="pin"
                          rules={{
                            required: "Enter pincode",
                            pattern: {
                              value: /^[0-9]{6,6}$/i,
                              message: "Pincode must be valid digits",
                            }, 
                            minLength: {
                              value: 6,
                              message: "Pincode must be 6 digits"
                            },
                            maxLength: {
                              value: 6,
                              message: "Pincode must 6 digits"
                            }
                          }}
                          render={({field}) => (
                            <TextField
                            {...field}
                            margin="normal"
                            label="Pincode"
                            required
                            error={!!errors?.pin}
                            helperText={errors?.pin?.message}
                            size="small"
                            fullWidth
                            />
                            )}
                            />
                      </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ position: 'relative',mt:1}}>
                        <TextField
                          // autoFocus
                          // {...field}
                          margin="normal"
                          label="Search Area"
                          required
                          size="small"
                          fullWidth
                          // value={placesInputRef?.current?.value}
                          inputRef={placesInputRef}
                          // error={!!errors?.searchArea}
                          // error={!locationCoordinates}
                        />
                      <Box id="map" component="div" sx={{width: '100%', height: 300}}></Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}  sx={{mt: 1}} >
                    <Controller
                      control={control}
                      name="contactNumber"
                      id="contactNumber"
                      rules={{
                        required: "Enter Contact Number",
                        pattern: {
                          value: /^[0-9]{0,100}$/i,
                          message: "Contact number must be valid digits",
                        }, 
                      }}
                      render={({field}) => (
                        <TextField
                          {...field}
                          margin="normal"
                          label="Contact Number"
                          required
                          error={!!errors?.contactNumber}
                          helperText={errors?.contactNumber?.message}
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 1}}>
                   <FormControl error={!!errors?.type} >
                     <FormLabel id="lib-type-group-label">Library Type *</FormLabel>
                     <Controller
                        control={control}
                        name="type"
                        id="type"
                        required
                        rules={{ required: "Select library type" }}
                        render={({field}) => (
                          <RadioGroup
                            {...field}
                            row
                            aria-labelledby="lib-type-group-label"
                            name="type"
                          >
                            {/* <FormControlLabel value="Academic" control={<Radio />} label="Academic" />
                            <FormControlLabel value="Private" control={<Radio />} label="Private" />
                            <FormControlLabel value="Public" control={<Radio />} label="Public" />
                            <FormControlLabel value="School" control={<Radio />} label="School" /> */}
                            {libraryTypes.map(type => <FormControlLabel key={type} value={type} control={<Radio />} label={type} />)}
                          </RadioGroup>
                        )}
                      />
                    </FormControl>
                  </Grid> 

                  <Grid item xs={12} sm={12} md={12} lg={12} >
                      <Controller
                        control={control}
                        name="hourlyBookingsEnabled"
                        id="hourlyBookingsEnabled"
                        render={({field}) => (
                          <FormControl
                            component="fieldset"
                            sx={{ mt: 2.4 }}
                            variant="standard"
                            {...field}
                          >
                            <FormGroup row>
                              <FormControlLabel
                                control={<Checkbox name="hourlyBookingsEnabled" />}
                                label="Enable hourly bookings"
                                checked={watch('hourlyBookingsEnabled') || false}
                              />
                            </FormGroup>
                          </FormControl>
                        )}
                      />
                    </Grid>

                  <Grid container item xs={12} sm={12} md={12} lg={12} sx={{mt: 2.2}} columnSpacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} >
                      <Controller
                        control={control}
                        name="seatCount"
                        id="seatCount"
                        rules={{
                          required: "Enter number of seats",
                          pattern: {
                            value: /^[0-9]{0,100}$/i,
                            message: "Only number are allowed",
                          }, 
                        }}
                        render={({field}) => (
                          <TextField
                            {...field}
                            margin="normal"
                            label="Number of Seats"
                            required
                            error={!!errors?.seatCount}
                            helperText={errors?.seatCount?.message}
                            size="small"
                            fullWidth
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Controller
                        control={control}
                        name="price"
                        id="price"
                        rules={{ required: "Enter price" }}
                        render={({field}) => (
                          <TextField
                            type="number"
                            {...field}
                            margin="normal"
                            label="Price"
                            required
                            error={!!errors?.price}
                            size="small"
                            InputProps={{
                              endAdornment: <InputAdornment position="start">/{watch('hourlyBookingsEnabled') ? 'hour' : 'day'}</InputAdornment>,
                            }}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Grid container item xs={12} sm={12} md={12} lg={12} sx={{mt: 1.6}} columnSpacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{mb: 1.2}}>
                      <label style={{color: 'rgba(0, 0, 0, 0.6)'}}>Working Hours *</label>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} sx={{mt: {xs: 1, md: 0}}}>
                      <LocalizationProvider dateAdapter={DateAdapter} >
                        <TimePicker
                          ampm={false}
                          label="From"
                          
                          // inputFormat="dd/MM/yyyy"
                          clearable={false}
                          value={fromHrs}
                          onChange={(newValue) => setFromHrs(newValue)}
                          renderInput={(params) => <TextField onKeyDown={(e) => {e.preventDefault();return false}}  {...params} size="small" sx={{width: '100%'}} />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6} sx={{mt: {xs: 1, md: 0}}} >
                      <LocalizationProvider dateAdapter={DateAdapter} >
                        <TimePicker
                          ampm={false}
                          label="To"
                          // inputFormat="dd/MM/yyyy"
                          clearable={false}
                          value={toHrs}
                          onChange={(newValue) => setToHrs(newValue)}
                          renderInput={(params) => <TextField onKeyDown={(e) => {e.preventDefault();return false}} {...params} size="small" sx={{width: '100%'}} />}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  
                  <Grid item xs={12} sm={12} md={12} lg={12} >
                    <Controller
                      control={control}
                      name="amenities"
                      id="amenities"
                      render={({field}) => (
                        <FormControl
                          component="fieldset"
                          sx={{ mt: 2.5 }}
                          variant="standard"
                          {...field}
                        >
                          <FormLabel component="legend">Amenities</FormLabel>
                          <FormGroup row>
                            {Object.keys(amenities).map((type, index) => (
                              <FormControlLabel
                                control={<Checkbox name={type} />}
                                label={type}
                                onChange={handleAmenitiesChange} 
                                checked={amenities[type] || false}
                                key={type}
                              />
                            ))}
                          </FormGroup>
                        </FormControl>
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} >
                    <Controller
                      control={control}
                      name="workingDays"
                      id="workingDays"
                      render={({field}) => ( 
                        <FormControl
                          component="fieldset"
                          sx={{ mt: 2.6 }}
                          variant="standard"
                          // {...field}
                        >
                        <FormLabel component="legend">Working Days</FormLabel>
                          <FormGroup row>
                            {Object.keys(weekDays).map((day, index) => (
                              <FormControlLabel
                                control={<Checkbox name={day.toLocaleLowerCase()} />}
                                label={day}
                                onChange={handleWorkingDaysChange} 
                                checked={workingDays[day.toLocaleLowerCase()] || false}
                                key={day.toLocaleLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FormControl>
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt:1}}>
                    <Controller
                      control={control}
                      name="overview"
                      id="overview"
                      rules={{ required: "Enter overview" }}
                      render={({field}) => (
                        <TextField
                          {...field}
                          multiline
                          rows={5}
                          margin="normal"
                          label="Overview"
                          required
                          error={!!errors?.overview}
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>

                  <Grid container item xs={12} sm={12} md={12} lg={12} sx={{mt: 2}}>
                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <Typography variant="h6" gutterBottom component="div">Terms</Typography>
                      <Divider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} >
                      <TextField
                        multiline
                        rows={3}
                        margin="normal"
                        label="Add text here"
                        size="small"
                        fullWidth
                        inputRef={termsInputRef}
                      />
                      <Button
                        type="button"
                        variant="contained"
                        sx={{ mt: 4, mb: 2 }}
                        startIcon={<ControlPointIcon />}
                        // color="success"
                        onClick={AddTerms}
                      >
                        Add
                      </Button>
                  
                      <List dense={true}>
                        {terms.map((ele, index) => (
                          <ListItem key={index}
                            secondaryAction={
                              <IconButton edge="end" aria-label="delete" onClick={() => deleteTerms(index)}>
                                <DeleteIcon />
                              </IconButton>
                            }
                          >
                          <ListItemIcon>
                            <ArrowRightIcon />
                          </ListItemIcon>
                          <ListItemText
                            primary={ele}
                              // secondary={secondary ? 'Secondary text' : null}
                            />
                          </ListItem>
                        ))}
                      </List>
                  </Grid>
                </Grid>
                
                {/* <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 2}}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="h6" gutterBottom component="div">Bank Details</Typography>
                    <Divider  sx={{mb: 2}}/>
                    <PropertyBankDetails propertyId={propertyId} vendorId={propertyData?.staged?.library?.createdBy} />
                  </Grid>
                </Grid> */}

                  <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 3, textAlign: 'center'}}>
                    <Button type="submit" variant="contained" color="success" >Save & Approve</Button>
                  </Grid>
                </Grid>
              </Box>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Stack direction="row" spacing={2}>
                <Button variant="contained"color="success" onClick={onApproveBtnClick}>Approve</Button>
                <Button variant="contained" color="error" onClick={onRejectBtnClick}>Reject</Button>
              </Stack>
            </TableCell>
            <ScrollDialog maxWidth="md" onModalClose={onModalClose} open={openRejectModal} title="Reject library" disableActions={true}>
              <LibraryRejection libraryId={propertyId} onCancel={onModalClose} onReject={onLibraryRejected} />
            </ScrollDialog>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer> 
  );
}
 
export default React.memo(PropertyInfo);


function LibraryRejection({libraryId, onCancel, onReject}) {

  const [error, setError] = useState(false);
  const [rejectionReason, setReason] = useState(false);

  const onRejectBtnClick = () => {
    if(rejectionReason){
      onReject({rejectionReason, libraryId});
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
        <TextField 
          label="Reason" 
          variant="outlined" 
          fullWidth
          multiline 
          minRows={5} 
          error={error} 
          onChange={(e) => {
            setError(false);
            setReason(e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={12} sm={12} lg={12} xl={12}>
        <Stack direction="row" columnGap={2} mt={3} justifyContent="right">
          <Button onClick={onCancel} color="secondary" variant='outlined'>Cancel</Button>
          <Button onClick={onRejectBtnClick} color="error" variant='contained' >Reject</Button>
        </Stack>
      </Grid>
    </Grid>
  )
}
